import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { CustomSelectDropdown } from "./custom.select";
import { selectStyle } from "../../../shared/fixtures/select_style";
import { getNewToken } from "../../../shared/helpers/util.country";
import { P } from "../Texts";

export const CountrySelect = (props) => {
  const [countries, setCountries] = useState([]);

  const getCountryToken = async () => {
    const countries = await getNewToken();
    setCountries(countries);
  };

  useEffect(() => {
    getCountryToken();
  }, []);

  return (
    <div className="mb-4">
      <label htmlFor={props.name}>
        <P fontSize="14px" fontFamily="semi" color="#47495C" className="mb-2">
          Country
          <span
            className=""
            style={{
              color: "#E62250",
            }}
          >
            *
          </span>
        </P>
      </label>
      <Controller
        control={props.control}
        {...props}
        defaultValue=""
        rules={props.validation}
        render={({ field }) => (
          <CustomSelectDropdown
            autoComplete="true"
            styles={selectStyle}
            {...field}
            className="w-full"
            placeholder="--Select a country--"
            options={countries}
            isLoading={countries?.length === 0}
            isDisabled={countries?.length === 0}
          />
        )}
      />
    </div>
  );
};
